module.exports = __webpack_public_path__ + "img/infrastructure-3.a654c2ed.png";